<footer class="footer">
    <div class="container-md pt-2 pt-md-0">
      <div class="d-flex justify-content-between flex-column flex-md-row align-items-center">
        <img height="60" width="161" alt="Regione Toscana" src="./assets/images/logo_regione_orizzontale.png"/>
        <div class="d-flex footer-right pt-2 pt-md-0">
          <div class="pe-2">Per assistenza:</div>
          <div class="d-flex flex-column">
            <div><fa-icon [icon]="['fas','envelope']" size="sm" class="pe-1 text-primary"></fa-icon><span>oscat&#64;regione.toscana.it</span></div>
            <div class="text-success"><fa-icon [icon]="['fas','phone']" size="sm" class="pe-1 text-success"></fa-icon><b>800 895 005</b></div>
          </div>
        </div>
      </div>
    </div>
</footer>